import React from 'react';

import CDNImage from '../../common/cdn-image';

const PrintImageContainer = props => {
  const orientationClass = (props.data.Height__Small_ >= props.data.Width__Small_) ?
    `product-view__image-container__portrait-${props.size.toLowerCase()}` : 
    `product-view__image-container__landscape-${props.size.toLowerCase()}`;

  let matClass = 'product-view__image-container__print-mat__';
  matClass += (props.frame === 'None') ? 'unframed-' : 'framed-';
  matClass += props.size.toLowerCase();

  let frameClasses =`product-view__image-container__print-frame__${props.size.toLowerCase()}`;
  frameClasses += ` product-view__image-container__print-frame__${props.frame.toLowerCase()}`;

  return (
    <button
      className="product-view__image-container"
      onClick={() => props.showLightbox(0) }
    >
      <div className="product-view__image-container__wrapper">
        <CDNImage
          imagePath={props.data.Image_File_Path}
          alt={props.data.Name}
          width={640}
          className={`product-view__image-container__print-frame ${orientationClass} ${frameClasses} ${matClass}`}
        />
      </div>
    </button>
  );
};

export default PrintImageContainer;